"use client";

import EventBus, {
	EventCallback,
	EventName,
	Events,
} from "@/lib/_event-bus/event-bus";
import { PageViewPayload } from "@/lib/_event-bus/events-payloads.types";

const OneTrustContent = {
	necessary_cookies: "C0001",
	performance_cookies: "C0002",
	functional_cookies: "C0003",
	targeting_cookies: "C0004",
};

const WINDOW_NAME = "_5874Hspt";

export class HubspotTracking {
	private enableLogging = false;

	constructor() {
		if (!this.isClientSide()) {
			return;
		}

		this.attachToWindow();
		this.attachEventListeners();

		// check for _hsq on window and create if doesn't exist
		if (!window._hsq) {
			window._hsq = [];
		}

		this.log({
			level: "debug",
			args: "HubspotTracking loaded",
		});
	}

	private attachToWindow() {
		if (typeof window === "undefined") {
			return;
		}

		window[WINDOW_NAME] = this;
	}

	private attachEventListeners() {
		if (typeof window === "undefined") {
			return;
		}

		const subscriptions = {
			[Events.pageView]: this.bind(this.handlePageViewEvent),
		} as Record<EventName, EventCallback<EventName>>;

		EventBus.subscribeMultiple(subscriptions);
	}

	private bind(handler: Function) {
		return handler.bind(this);
	}

	private log(params: {
		level: "debug" | "error";
		function?: string;
		args: any;
	}) {
		if (!this.enableLogging) {
			return;
		}

		const functionPart = params.function ? `~ ${params.function}` : "";

		console[params.level](`🧠 ~ HubspotTracking ${functionPart}`, params.args);
	}

	private isClientSide() {
		if (typeof window === "undefined") {
			return false;
		}

		return true;
	}

	private hasConsent(): boolean {
		if (!this.isClientSide()) {
			return false;
		}

		const onetrustActiveGroups = window.OnetrustActiveGroups;

		if (!onetrustActiveGroups) {
			return false;
		}

		return onetrustActiveGroups.includes(OneTrustContent.functional_cookies);
	}

	public handlePageViewEvent(event: PageViewPayload) {
		if (!this.hasConsent()) {
			this.log({
				level: "debug",
				function: "handlePageViewEvent",
				args: "consent is not given",
			});
			return;
		}

		const { session } = event;

		if (!session) {
			this.log({
				level: "debug",
				function: "handlePageViewEvent",
				args: "session not in event",
			});
			return;
		}

		let hsq = window?._hsq;

		if (!hsq) {
			this.log({
				level: "error",
				function: "handlePageViewEvent",
				args: "window._hsq.push is undefined",
			});
		}

		hsq.push([
			"identify",
			{
				email: session.user.email,
			},
		]);

		hsq.push(["trackPageView"]);

		this.log({
			level: "debug",
			function: "handlePageViewEvent",
			args: "pushed events",
		});
		return;
	}
}
